/**
 * GDPR Redirects
 * 
 * This component handles redirects for European Union users to satisfy GDPR
 */
/**
 * GDPR Redirect
 * Handle GDPR compliance by detecting and redirecting all EU traffic
 * 
 * Config Options
 * -- gdprRedirectPage : Override for the page that this will redirect to. {{host}} will be replaced with the host the script is running on. eg: l.beliefnet.com
 */
 define('components/gdpr-redirect',[
    'jquery',
    'logging',
    'location',
    'utilities',
    'application'
], function($, logging, location, utilities, app) {
    'use strict';
    
    var _ModuleName = "GDPR Redirects";
    var _config = { 
        enabled: true,
        redirect: {
            page: "https://{{host}}/sorry-unavailable/?utm_medium=referral&utm_source=offers_unavailable",
            token: "{{host}}"
        },
        testing: {
            enabled: false,
            param: "bnet-gdpr-test"
        }
    }

    var init = function(config) {
        // If a gdpr redirect page override was configured,
        // update the config
        if(config && config.gdprRedirectPage) {
            _config.redirect.page = config.gdprRedirectPage;
        }

        if (_config.enabled || (_config.testing.enabled && utilities.getParameter(document.URL, _config.testing.param) == "true")) {
            // Check location and if EU, redirect
            logging.debug("Checking location for EU", _ModuleName);
            location.isEuropeanUnion(function() {
                if(app.getProcessVersionNumber() == '2.0') {
                    logging.debug("GDPR Check indicates UE. Notifying parent we need to propogate.", _ModuleName);

                    app.notifyParentComplete();
                } else {
                    // We are in the EU
                    var redirectPage = _config.redirect.page.replace(_config.redirect.token, location.host);
                    logging.debug("You are located in the EU, so we are redirecting to " + redirectPage, _ModuleName);
                    window.location = redirectPage;
                }
            }, function() {
                logging.debug("You are NOT located in the EU", _ModuleName);
            });
        } else {
            logging.debug("GDPR Redirect component is disabled", _ModuleName);
        }
    }

    var run = function() { }

    return {
        init: init,
        run: run
    }
});
